 <template>
	<div>
		<el-drawer
			:title="name+'座位号管理'"
			:visible.sync="drawerShow"
			:wrapperClosable="false"
			:destroy-on-close="true"
			size="auto"
			@close="close"
		>
			<div class="drawer-content">
				<div class="temp-head clearfix">
					<div class="font16 MB20">1、请先下载售票座位号导入表，在表格中填写每张售票对应的座位号</div>
					<el-button type="primary" @click="download()" size="small" :loading="downLoading">下载座位号导入表</el-button>					
				</div>                            
				<div class="temp-head clearfix MT20">
					<div class="font16 MB20">2、填写好售票座位号导入表后，在下方上传。上传成功后会在用户票夹中显示座位号。</div>
					
						<div class="MT20">
							<el-upload
								action
								:http-request="uploadExcel"
								:auto-upload="false"
								ref="upload"
								accept=".xls, .xlsx"
								:show-file-list="true"
								:before-upload="beforeUpload"
								:file-list="fileList"
								:on-change="onChange"
								:on-remove="onRemove"
								:disabled="uploadLoading"
								style="width:100%">
								<el-button size="small" style="float: left;" type="primary" :loading="uploadLoading">{{uploadLoading ? '上传中' : '上传座位号导入表'}}</el-button>
							</el-upload>
						</div>
						<div class="download color-blue MT20" v-if="siteFileUrl" style="cursor: pointer;" @click="downloadExcel(siteFileUrl)">
							{{name}} 座位号表.excel
						</div>
						<div v-if="MsgText"  class="MT20" >
							<el-alert show-icon type="error" v-if="MsgText" :closable="false">
								<div slot="title">上传失败：{{MsgText}}</div>
							</el-alert>
						</div>
						
				</div>				
				<div class="MT20">                    
					<div class="font16">3、座位号展示时间</div>
					<el-radio-group v-model="buildTime">						
						<div class="MT20"><el-radio :label="3">创建后立即展示</el-radio></div>
						<div class="MT20"><el-radio :label="0">自定义时间</el-radio></div>
					</el-radio-group>
					<div class="MT20">
						<el-date-picker
						    v-model="datetimerange"
						    type="datetime"
						    value-format="yyyyMMddHHmmss"
						    default-time="23:59:59"
						    placeholder="选择展示时间"
						    :picker-options="endTimeOptions"
							v-if="buildTime == 0 " style="width: 100%;"
							>
						</el-date-picker>
					</div>					
				</div>                
			</div>
			<div class="drawer-footer">
			    <el-button v-if="!btnLoading" @click="close">取消</el-button>
			    <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
			        >提交</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';


export default {
    props:{
        activityId:{
            type:[Number,String],
            default:1
        }
    },
    data() {
        return {
            drawerShow:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,      
            fileList:[],
            sessionId:'',
            name:'',			
			datetimerange:'',
			endTimeOptions: {
			    disabledDate(time) {
			        return time.getTime() < Date.now() - 1000 * 60 * 60 * 24 * 1;
			    }
			},
            buildTime:3,
            MsgText:'',
			siteFileUrl:'',
			
			
			canSubmit:true,
        };
    },
    components:{},
    methods: {
        show(data) {
			console.log(data)
			//console.log(item)
        	this.data = data;		
            this.sessionId = data.sessionId;
			this.siteFileUrl = data.siteFileUrl;
            this.name = data.sessionName;
			if (data.buildTime === 3 || data.buildTime == null) {
			        this.buildTime = 3;
			        this.datetimerange = '';
			    } else {
			        this.buildTime = 0;
			        this.datetimerange = String(data.buildTime);
			    }
            this.drawerShow = true;        	
        },
        close(){            
            this.drawerShow = false;
			this.sessionIds = '';
            this.errorData = [];
			this.datetimerange = '';
			this.canSubmit = false;
			this.btnLoading = false;
			this.fileList = []
        },
		async downloadExcel(item){
		    const _item = item;		    
			await downloadFileTmp(_item, this.name + '座位号导入表.' + this.$utils.getFileType(_item));		   
		},
		//下载模板
		download(){
			let filePath;
			this.downLoading = true;			
			this.$request({
				url: '/activity/seat/template',
				method: 'POST',
				params: {sessionId:this.sessionId } ,
			}).then(res => {
				const { state, msg, result } = res.data;
				if( state == 1 && result ){
					filePath = result.url;					
					downloadFileTmp(filePath,`场次售票导入座位号模板.`+this.$utils.getFileType(filePath));
					this.downLoading = false;					
				}else{
					this.downLoading = false;					
					return this.$message.error(msg || '下载失败');
				}
			}).catch(() => {
				this.$message.error('请求错误');
			}).finally(() => {				
				this.downLoading = false;
			});
		},
		onSubmit(){
			// 上传前校验时间
			if( this.buildTime == 0 && this.datetimerange == '' ){
				return this.$message.error( '自定义时间不能为空！');
			}
			this.$refs.upload.submit();
		},
		// 计算 buildTime 参数
		getBuildTime(){
			if( this.buildTime == 3 ){
				return 3;
			}
			return this.datetimerange.replace(/-/g, '').replace(/:/g, '').replace(/ /g, '');
		},
		async uploadExcel(req){
		    this.btnLoading = true;
		    this.uploadLoading = true;
		    const formData = new FormData();
		    formData.append('file', req.file);
			
			
		    let filePath; let fileFullPath;
		    const res = await uploadFileTmp(formData).catch(err => {
		        this.$message({message: err.message, type: 'error'});
		    }).finally(() => {
		        this.uploadLoading = false;
		    });
		    const{state,msg,result} = res.data;
		    if (state == 1 && result) {
		        filePath = result.url;
				fileFullPath = result.urlFull;
		    }else{
		        this.$message.error(msg || '上传失败');
				return;
		    }
			var _buildTime = this.getBuildTime();
		    this.$request({
		        url:'/activity/seat/save',
		        method: 'post',
		        data:{
		            filePath:filePath,
					fileFullPath:fileFullPath,
		            buildTime:_buildTime,
					sessionId:this.sessionId.toString()
		        }
		    })
		        .then(res => {
		            const{state,msg,result} = res.data;
		            if (state == 1) {
		                if(result && result.importErrorDetailVOList && result.importErrorDetailVOList.length > 0){
		                    this.$refs.errorMsgDrawer.show(result);
		                }else{
		                    this.onSuccess();
		                }
		                
		            }else{
		                this.$message.error(msg || '上传失败');
		                this.canSubmit = false;
		            }
		        })
		        .catch(err => {
		            this.canSubmit = false;
		            this.$message({message: err.message, type: 'error'});
		        })
		        .finally(() => {
		            this.btnLoading = false;
		            this.canSubmit = true;
		        });
		},
		beforeUpload(file){
		    const type = this.$utils.getFileType(file.name)
		    const isType = type === 'xls' || type === 'xlsx';
		    if (!isType) {
		        this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
		    }
		    return isType;
		},
		onSuccess(){
		    this.$emit('onUpdate');
		    this.close();
		},
		onChange(file){
		    if( file ){
		        this.fileList = [{...file}]
		        this.canSubmit = false;
		    }else{
		        this.canSubmit = true;
		    }
		},
		onRemove(){
		    this.canSubmit = true;
		}
        
        
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>